"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backwardCompatQuery = void 0;
const AnswerFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/AnswerFieldType"));
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function backwardCompatQuery(query) {
    if (!query)
        return;
    const validKeys = Object.values(QueryFieldKey_1.default);
    // Sort By
    if (`${query.sortBy}` === '[object Object]')
        delete query.sortBy;
    if (`${query.sortBy}` === undefined)
        delete query.sortBy;
    replaceSiteWithPlace(query, 'sortBy');
    // Clean Up Filters
    if (!query.filters)
        query.filters = query['filterBys'];
    query.filters = (query.filters || [])
        .map((filter) => {
        // Rename key to queryFieldKey
        if (!filter.queryFieldKey)
            filter.queryFieldKey = filter['key'];
        if (filter.queryFieldKey === QueryFieldKey_1.default.OPDEFINITION) {
            filter.hidden = true;
            filter.veryHidden = true;
        }
        // Momentize Dates
        if (filter.from) {
            filter.from = (0, moment_timezone_1.default)(filter.from);
            filter.to = (0, moment_timezone_1.default)(filter.to);
        }
        return filter;
    })
        // Remove Stale QueryFields
        .filter(f => validKeys.indexOf(f.queryFieldKey) >= 0);
    // Clean Up GroupBys
    query.groupBys = (query.groupBys || [])
        .map((gb) => {
        // Rename Variant to fieldType
        if (!gb.queryFieldKey)
            gb.queryFieldKey = gb['key'];
        if (!gb.timeInterval)
            gb.timeInterval = gb['otherKey'];
        return gb;
    })
        // Remove Stale QueryFields
        .filter(f => validKeys.indexOf(f.queryFieldKey) >= 0);
    // Clean Up Fields
    query.fields = (query.fields || [])
        .map(field => {
        if (!field)
            return undefined;
        // Rename SITE to place
        replaceSiteWithPlace(field, 'key');
        replaceSiteWithPlace(field, 'propertyName');
        replaceSiteWithPlace(field, 'gqlFields');
        // Rename type to fieldType
        if (!field.fieldType)
            field.fieldType = field['type'];
        // Move renderer into object
        Object.assign(field, field['renderer'] || {});
        // Rename type to fieldType
        if (!field.fieldType)
            field.fieldType = field['type'];
        // Convert old Field Types
        field.fieldType = convertOldViewFieldTypes(field.fieldType);
        // Convert old PARAMS
        if (!field.propertyName && field['params'])
            field.propertyName = field['params'][0];
        // Make sure Question Answer Fields grab a form
        if (field.key === ViewFieldKey_1.default.QUESTIONANSWER) {
            if (!field.questionNodeId) {
                field.questionNodeId = field.propertyName;
            }
            field.gqlFields = 'form, isScoreEnabled';
        }
        // Make sure Question Answer Fields grab a form
        if (field.key === ViewFieldKey_1.default.QUESTIONANSWER) {
            if (!field.questionNodeId) {
                field.questionNodeId = field.propertyName;
            }
            field.gqlFields = 'form, isScoreEnabled';
        }
        // NEW NAME FOR OP PASS STATUS
        if (`${field.key}` === 'opPassFailStatus')
            field.key = ViewFieldKey_1.default.OP_PASSSTATUS;
        // NEW NAME FOR COMPLETOR
        if (`${field.key}` === 'completor') {
            field.key = ViewFieldKey_1.default.OP_SUBMITTEDBY;
            field.propertyName = ViewFieldKey_1.default.OP_SUBMITTEDBY;
            field.label = 'Submitted By';
            field.description = 'The user who submitted the Op';
            field.gqlFields = 'submittedBy { id, title, profileImageUrl }';
        }
        if (!!ViewFieldRegistry_1.default[field.key]) {
            return ViewFieldRegistry_1.default[field.key];
        }
        return Object.assign({}, field);
    })
        .filter(field => !!field);
}
exports.backwardCompatQuery = backwardCompatQuery;
exports.default = backwardCompatQuery;
function convertOldViewFieldTypes(old) {
    switch (old) {
        case 'rowkey':
            return BasicFieldType_1.default.ROW_KEY;
        case 'answers':
            return AnswerFieldType_1.default.ANSWER_CHECK;
        case 'basic':
            return BasicFieldType_1.default.STRING;
        case 'enabled':
            return BasicFieldType_1.default.OPDEF_ENABLED;
        case 'issueflag':
            return StaticFieldType_1.default.ISSUE_FLAG;
        case 'issuestatus':
            return StaticFieldType_1.default.ISSUE_STATUS;
        case 'issuetype':
            return StaticFieldType_1.default.ISSUE_TYPE;
        case 'issueOp':
            return BasicFieldType_1.default.RELATED_MODEL;
        case 'moment':
            return BasicFieldType_1.default.DATE;
        case 'many':
            return BasicFieldType_1.default.RELATED_MODEL;
        case 'spt':
            return BasicFieldType_1.default.RELATED_SPT;
        case 'usertype':
            return StaticFieldType_1.default.USER_TYPE;
        case 'opstatus':
            return StaticFieldType_1.default.OP_STATUS;
        case 'orgstatus':
            return StaticFieldType_1.default.ORG_STATUS;
        case 'opissue':
            return BasicFieldType_1.default.RELATED_MODEL;
        case 'adhocop':
            return BasicFieldType_1.default.OP_ISADHOC;
        case 'person':
            return BasicFieldType_1.default.RELATED_USER;
        case 'taskstatus':
            return StaticFieldType_1.default.TASK_STATUS;
        case 'score':
            return BasicFieldType_1.default.OP_SCORE;
        case 'inviteToAppStatus':
            return StaticFieldType_1.default.STAFF_APPSTATUS;
        default:
            return old;
    }
}
function replaceSiteWithPlace(o, p) {
    if (!!(o === null || o === void 0 ? void 0 : o[p]))
        o[p] = o[p].toString().split('site').join('place');
}
